import { ComponentProps } from 'react';

import { Volume } from '~/shared/types/api';
import { formatBytes } from '~/shared/utils/formatNumber';
import Tag from '~/shared/components/Tag';

export const statusToTagVariantMap: {
  [k in Volume['monitoring']]: ComponentProps<typeof Tag>['variant'];
} = {
  Managed: 'green',
  Migrating: 'green',
  Datafied: 'green',
  Detaching: 'green',
  Unmonitored: 'gray',
  Unmigrating: 'gray',
  Unknown: 'gray',
  Growing: 'purple',
  Shrinking: 'purple',
  Merging: 'purple',
  Modifying: 'purple',
  Unattached: 'dark-blue',
  Deleted: 'dark-blue',
  Monitored: 'cyan',
  Failed: 'orange',
};

export function getDatafyUtilization(volume?: Volume) {
  const { diskUsed, datafyDiskSize } = volume || {};

  if (!diskUsed || !datafyDiskSize || diskUsed === 0 || datafyDiskSize === 0) {
    return 'N/A';
  }

  const utilizationPercent = Math.round((diskUsed / datafyDiskSize) * 100);
  return `${utilizationPercent}% (${formatBytes(diskUsed)})`;
}

export function getFilterSearchParams(
  filters: {
    field: 'monitoring' | 'sourceVolume' | 'volumeId' | 'instanceId' | 'diskType';
    value: string;
    op: 'equals';
  }[]
) {
  return [
    ...filters.map(({ field, value, op }) => ['filters', JSON.stringify({ field, value, op })]),
  ];
}

export const datafyDevelopmentTenantId = [
  '79c406c5-7b64-43f2-ba76-9b01e74e3d90',
  'c7503430-6ffd-4625-87a8-2acc7979e198',
];
